export enum GenericPage {
  History = "/capital/history",
}

export enum CashAdvancePage {
  Dashboard = "/capital/cash-advance/dashboard",
  Arvato = "/capital/cash-advance/collections",
  Goodbye = "/capital/sunset",
}

export enum UtilPaths {
  DebuggerRedirect = "/capital/debugger-redirecting",
  Root = "/capital",
}

export enum TermLoansPage {
  Dashboard = "/capital/business-loan/dashboard",
}
